import React from 'react';
import { Box, Container, Heading, Flex, Button, ButtonGroup, Divider, HStack, useColorModeValue, Image, Text } from '@chakra-ui/react';
import { ArrowBackIcon, ViewIcon, ChevronUpIcon, DownloadIcon } from '@chakra-ui/icons';
import { Link, useNavigate } from 'react-router-dom';
import NewKanbanBoard from '../components/leads/NewKB';

/**
 * Page component for displaying the main Kanban board
 * This is now the default board shown on the home page
 */
const NewKanbanBoardPage = () => {
  const bgColor = useColorModeValue('gray.50', 'gray.900');
  const navigate = useNavigate();
  
  return (
    <Box bg="#fef4db" minH="100vh" width="100%" overflow="hidden">
      <Box width="100%" overflowY="hidden">
        <Flex 
          justify="space-between" 
          align="center" 
          p={4}
          bg="#fef4db"
        >
          <HStack spacing={3}>
            <Box as="a" href="https://sumaroh.com" target="_blank" rel="noopener noreferrer">
              <Image src="/logo.png" alt="Logo" height="30px" ml={3} />
            </Box>
            <Text color="#63410d" fontSize="xl" fontWeight="thin">|</Text>
            <Heading size="lg" color="#63410d" fontWeight="thin">CRM</Heading>
          </HStack>
          
          <ButtonGroup size="sm" spacing={2}>
            <Button
              leftIcon={<ViewIcon />}
              variant="ghost"
              color="#7c5913"
              _hover={{ bg: '#f9e8c0' }}
              onClick={() => navigate('/tasks')}
              size="sm"
            >
              Tasks
            </Button>
            
            <Button
              leftIcon={<ViewIcon />}
              variant="ghost"
              color="#7c5913"
              _hover={{ bg: '#f9e8c0' }}
              onClick={() => navigate('/sheets')}
              size="sm"
            >
              Lead Sync
            </Button>
            
            <Button
              leftIcon={<ChevronUpIcon />}
              variant="ghost"
              color="#7c5913"
              _hover={{ bg: '#f9e8c0' }}
              onClick={() => navigate('/analytics')}
              size="sm"
            >
              View Analytics
            </Button>
            
            <Button
              leftIcon={<DownloadIcon />}
              variant="ghost"
              color="#7c5913"
              _hover={{ bg: '#f9e8c0' }}
              onClick={() => navigate('/exports')}
              size="sm"
            >
              Exports
            </Button>
            
            <Button
              variant="solid"
              colorScheme="blue"
              size="sm"
              onClick={() => navigate('/tanstack')}
            >
              Try TanStack Version
            </Button>
            
            <Divider orientation="vertical" height="20px" />
            
            <Link to="/old-kanban">
              <Button 
                leftIcon={<ArrowBackIcon />} 
                variant="outline" 
                size="sm"
                borderColor="#d4ac57"
                color="#7c5913"
                _hover={{ bg: '#f9e8c0' }}
              >
                View Legacy Kanban
              </Button>
            </Link>
          </ButtonGroup>
        </Flex>
        
        {/* The main Kanban board component - scaled to 90% to improve layout */}
        <Box 
          width="100%" 
          bg={bgColor}
          borderTopRadius="md"
          mt={1}
          p={3}
          sx={{
            transform: 'scale(0.9)',
            transformOrigin: 'top left',
            width: '111%', /* Compensate for scale to use full width (100/0.9 ≈ 111) */
            minHeight: '111vh', /* Ensure enough space for the scaled content */
            marginBottom: '-11vh' /* Correct the extra space at the bottom */
          }}
        >
          <NewKanbanBoard />
        </Box>
      </Box>
    </Box>
  );
};

export default NewKanbanBoardPage;
